import { Button, ButtonProps } from "@mui/material";

export const MyDelaemTsenyDostupnymi = (props: ButtonProps) => {
  return (
    <Button variant="contained" color="secondary" href="/po-karmanu" {...props}>
      Мы делаем цены на любые продукты доступными
    </Button>
  );
};
